import { useEffect, useState } from "react";
import { formatDate, getAvatarUrl } from "src/Common/common";
import { handleError } from "src/Common/function";
import Pagination from "src/Components/Pagination";
import HistoryService from "src/Services/API/history.service";

const History = ({ woId }) => {
  const [historyArray, setHistoryArray] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setPageNumber(0);
  }, [woId]);

  useEffect(() => {
    if (!woId) {
      setHistoryArray([]);
      setTotalItems(0);
      setPageSize(10);
      setTotalPages(1);
      return;
    }

    HistoryService.getAllByWoIdPaginated(woId, pageNumber)
      .then((response) => {
        if (response.status === 200) {
          const payload = response?.data?.data ?? response?.data ?? {};
          const historyList = Array.isArray(payload?.history)
            ? payload.history
            : Array.isArray(payload?.histories)
              ? payload.histories
              : [];
          const apiTotalItems = Number(payload?.totalCount ?? historyList.length ?? 0);
          const inferredPageSize =
            pageNumber === 0 && historyList.length > 0 ? historyList.length : pageSize > 0 ? pageSize : 10;
          const computedPages = inferredPageSize > 0 ? Math.ceil(apiTotalItems / inferredPageSize) : 1;

          setHistoryArray(historyList);
          setTotalItems(apiTotalItems);
          setPageSize(inferredPageSize);
          setTotalPages(computedPages > 0 ? computedPages : 1);
        }
      })
      .catch((error) => handleError(error));
  }, [woId, pageNumber]);

  const hasHistory = totalItems > 0 || historyArray.length > 0;

  return (
    <>
      {!hasHistory && (
        <div className="w-full py-2">
          <span className="font-OpenSansRegular font-[400] text-[12px] text-gray-500">No history found</span>
        </div>
      )}

      {hasHistory && (
        <>
          <table className="w-full border-solid border-b-[1px] border-borderColor mb-3">
            <tbody>
              {historyArray.map((history, index) => (
                <tr key={index}>
                  <td className="w-[150px]">
                    <div className="font-OpenSansRegular px-[5px] py-[5px] text-left text-[12px] font-[400] col-span-1 text-titleColor">
                      {formatDate(history.createdAt)}
                    </div>
                  </td>
                  <td className="w-[200px] ">
                    {history.user && (
                      <div className="w-full flex items-center">
                        <img src={getAvatarUrl(history.user.avatar)} className="w-[20px] rounded-[10px]" />
                        <div className="font-OpenSansRegular px-[5px] py-[5px] text-left text-[12px] font-[400] col-span-1 text-titleColor">
                          {history.user.name}
                        </div>
                      </div>
                    )}
                  </td>
                  <td>
                    <div className="font-OpenSansRegular px-[5px] py-[5px] text-left text-[12px] font-[400] col-span-1 text-titleColor ">
                      {history.description}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            currentPage={pageNumber + 1}
            totalPages={totalPages}
            totalItems={totalItems}
            pageSize={pageSize}
            onPageChange={(page) => setPageNumber(page - 1)}
          />
        </>
      )}
    </>
  );
};

export default History;
